<template>
  <div>
    <section-title
      :bg-icon="getBgIcon()"
      class="cursor-pointer"
      :icon="getIcon()"
      reverse
      :title="title"
      title-class="mb-1 bg-transparent"
      @on-click="isVisible = !isVisible"
    />
    <transition name="list">
      <div v-show="isVisible" class="card-body p-0 mb-4 ml-3">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import SectionTitle from '@/shared/components/SectionTitle.vue';

export default {
  name: 'SectionTitleCollapse',
  components: {
    SectionTitle,
  },
  props: {
    title: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    getIcon() {
      return this.isVisible ? 'fas fa-chevron-down' : 'fas fa-chevron-right';
    },
    getBgIcon() {
      return this.isVisible ? 'orange' : 'green';
    },
  },
};
</script>

<style lang="scss" scoped></style>
